<template>
  <div class="bees_fans_list">
    <van-sticky>
      <NavTitle title="我的粉丝" />
    </van-sticky>
    <div class="bees_fans_content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="bees_fans_item van-hairline--top" v-for="(item,index) in list" :key="index" @click="userChatfun(item)">
            <div class="bees">
              <van-image round fit="cover" width="60" height="60" :src="item.userHeadImage"></van-image>
              <p class="van-ellipsis p1">{{item.userName}}</p>
            </div>
            <p class="p2">关注时间:{{item.createTime}}</p>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
import NavTitle from './components/navTitle'
import http from '@/utils/axios';
import utils from '@/utils/common';
export default {
  data(){
    return {
      list: [],
      pageNum:1,
      loading: false,
      finished: false,
      refreshing: false,
    }
  },
  methods:{
    onLoad(){
      let parmes={
        "pageNum": this.pageNum,
        "pageSize": 10,
      }
      http({
        url:'/order/appuser/userfollow/fanslist',    // 江要求更换接口  11739
        method:'POST',
        parmes:parmes
      }).then(rps=>{
        if (rps.code == 200) {
          if (rps.data.pages == 0) {
            this.finished = true;
          } else {
            if (rps.data.list.length === 0) {
              this.finished = true;
            } else {
              this.finished = false;
              this.pageNum++;
            }
            this.list = this.list.concat(rps.data.list);
          }
          this.loading = false;
        }
      })
    },
    onRefresh(){
      setTimeout(() => {
        this.refreshing = false;
        this.list=[];
        this.pageNum=1;
        this.onLoad()
      }, 2000);
    },
    userChatfun(item){
      utils.userChat(item.userId)
    }
  },
  created(){
    this.$loading.hide();
  },
  components:{NavTitle}
};
</script>
<style lang="less" scoped>
.bees_fans_list{
  background: white;
  .bees_fans_item{
    display: flex;
    padding: 10px 30px;
    justify-content: space-between;
    align-items: center;
    .bees{
      display: flex;
      flex: 1;
      align-items: center;
      .p1{
        width: 290px;
        font-size: 28px;
        color: #333;
        padding-left: 20px;
        box-sizing: border-box;
      }
    }
    .p2{
      width: 235px;
      font-size: 20px;
      color: #999999;
    }
  }
}
</style>